import React from "react";
import { Link } from "react-router-dom";

/**
 * Breadcrumb component with support for hierarchical paths
 *
 * @param {string} title - Page title (h1)
 * @param {string} breadtitle - Current page name in breadcrumb (defaults to title)
 * @param {boolean} compact - Use compact styling
 * @param {Array} parents - Array of parent breadcrumb items: [{ label: "Servicios", path: "/servicios" }]
 */
const Breadcrumb = ({ title, breadtitle, compact = false, parents = [] }) => {
  return (
    <div className={`breadcumb-wrapper ${compact ? 'breadcumb-compact' : ''}`}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">{title}</h1>
              <ul className="breadcumb-menu">
                <li>
                  <Link to="/">Home</Link>
                </li>
                {parents.map((parent, index) => (
                  <li key={index}>
                    <Link to={parent.path}>{parent.label}</Link>
                  </li>
                ))}
                <li className="active">{breadtitle || title}</li>
              </ul>
            </div>
          </div>
          {!compact && (
            <div className="col-lg-6 d-lg-block d-none">
              <div className="breadcumb-thumb">
                <img src="/assets/img/normal/wcu-3.png" alt="LealChapayPintura" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
